import { useEffect, useState } from 'react'
import { DonateButton } from 'ppp'

export const StickyPhone = (props) => {

  const[visible, setVisible] = useState(false)
  const[left, setLeft] = useState(0)

  const handleScroll = (event) => {
    var triggerDistance = document.querySelector('#ppp-sticky-anchor').getBoundingClientRect().top
    var untriggerDistance = document.querySelector('footer').getBoundingClientRect().top - window.innerHeight
    if (triggerDistance <= 0 && untriggerDistance >= 0) {
      setVisible(true)
    } else {
      setVisible(false)
    }
  }

  const handleResize = (event) => {
    let bodyLeft = document.querySelector('body').getBoundingClientRect().left
    if (bodyLeft < 0) bodyLeft = 0
    setLeft(bodyLeft)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', handleResize)
    handleResize()
  }, [])

  return <div className="phone-sticky-wrapper" style={{ opacity: visible ? 1 : 0, left: left }}>
      <div className="sticky-wrapper justify-between align-items-center d-flex">
        <DonateButton project={props.project} status={props.status} gaAction='click donate_button__sticky' />
      </div>
    </div>
}
